export default __webpack_public_path__ + "static/media/janela-vidro.29742400.svg";